module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isExist),
      expression: "isExist"
    }],
    class: _vm.classes
  }, [(_vm.currentItem) ? _c('a', {
    staticClass: "my-link",
    attrs: {
      "href": _vm.currentItem[("url_" + _vm.mq)],
      "target": _vm.currentItem.blankWindow
    },
    on: {
      "click": function($event) {
        _vm.onItemClick(_vm.currentItem, $event)
      }
    }
  }, [_c('img', {
    staticClass: "my-current-item",
    class: _vm.currentItemClasses,
    attrs: {
      "src": _vm.currentItem[("fileName_" + _vm.mq)],
      "alt": ""
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "my-rotate-transition"
    },
    on: {
      "before-enter": function($event) {
        _vm.$emit('next-item-before-enter')
      },
      "after-enter": function($event) {
        _vm.$emit('next-item-after-enter')
      }
    }
  }, [(_vm.nextItem) ? _c('img', {
    staticClass: "my-next-item",
    attrs: {
      "src": _vm.nextItem[("fileName_" + _vm.mq)],
      "alt": ""
    }
  }) : _vm._e()])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3cd0b2a","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared/bc-banner/components/Rotate.vue
// module id = 503
// module chunks = 1